<template>
<!-- 生活直播 -->
  <div class="voiceRoom" v-wechat-title="this.title">
    <div class="isheader" style="background: #E8E8E8; height: 0.88rem;">
      <div>
        <img src="../../assets/voiceLogo1.png" alt="logo" class="logo1">
        <img src="../../assets/voiceLogo2.png" alt="logo" class="logo2">
      </div>
      <img src="../../assets/btn_download2.png" alt="下载" class="download" @click="download">
    </div>
    <div class="isContainer">
       <div class="isTop">
         <div class="realTop">
            <img :src="dataInfo.img" alt="logo" class="isImg">
            <p class="isName">{{dataInfo.name}}</p>
         </div>
         <div class="realBottom">
           <div class="isroom">
              <p class="isTitle">{{dataInfo.title}}</p>
              <div class="timeNumber">
                  <p class="isTime">预计开始时间 {{dataInfo.startTime | formatDate}}</p>
                  <div class="imgName"><img src="../../assets/voiceNumber.png" alt="">
                   <p> {{dataInfo.isNumber}}人在线</p>
                  </div>
              </div>
              <div class="imgName">
                <p class="imgName1">
                    <img :src="dataInfo.img" alt="logo" class="isImg">
                    <span class="isName">{{dataInfo.name}}</span>
                </p>
                <p class="inroom">
                    <img src="../../assets/inRoom.png" alt="logo">
                    <!-- 进入房间 -->
                </p>
              </div>
            </div>
         </div>
       </div>
       <img src="../../assets/voice222.png" alt="logo" class="step step1">
       <img src="../../assets/voice3.png" alt="logo" class="step step2">
       <img src="../../assets/voice4.png" alt="logo" class="step step3">
    </div>
    <myfooter :isContent="isContent"></myfooter>  
    <toast></toast>
  </div>
</template>
<script>
  import  myfooter from '../commen/myfooter'
  import cbct from '../../../static/js/base.js'
  import toast from '../commen/toast.vue'
  import share from '../../../static/js/share.js';
  import qs from 'qs'
  export default {
    name: 'voiceRoom',
    props: {
    
    },
    data(){
      return {
        title:"听见广播",
        roomNumber:'',//语音房id
        isContent:'下载听见广播',
        dataInfo:{
          img:'',
          name:'',
          title:'',
          startTime:'',
          isNumber:'0',
        },
      }
    },
    filters:{
      peopleNumber:function(n1){
          if(n1!=undefined) {
            let strNum="";
          if (n1.length>=5) {
            strNum=(parseFloat(n1/10000).toFixed(1))
          }else{
            strNum=n1
          }
            return strNum     
          }
      },
       // 转换时间
      formatDate(time) {
            var date = new Date(time*1000);
            return cbct.formatDate(date, 'MM-dd hh:mm:ss');
      },
    },
  created(){
    let self=this;
    if(self.$route.query.roomNumber){
      self.roomNumber=self.$route.query.roomNumber;
    }
    this.getInfo();
  },
  methods:{
      download(){
        this.$router.push({path:"downloadApp?isFrom=programRecorded"});
      },
      getInfo(){
        let self = this;
        self.$api.post(cbct.baseurl+"share/voiceRoom",qs.stringify(  {'room_number':this.roomNumber} )).then(function(res){
          if (res.c==cbct.code.successCode) {
             self.dataInfo.img = res.d.avatar;
             self.dataInfo.name = res.d.nickname;
             self.dataInfo.title = res.d.topic;
             self.dataInfo.startTime = res.d.topic_start;
             self.dataInfo.isNumber = res.d.rt_spectators;
             self.title=res.d.topic;
            share.share(self,window.location.href,'房间名称'+res.d.info.topic,'主持人'+res.d.info.nickname,'https://seefm.oss-cn-beijing.aliyuncs.com/image/see_fm_1238965.png');
            share.QQshare(self,window.location.href,'房间名称'+res.d.info.topic,'主持人'+res.d.info.nickname,'https://seefm.oss-cn-beijing.aliyuncs.com/image/see_fm_1238965.png');
          }else{
            self.bus.$emit('toast',{show:true,title:res.m})
            }   
          }).catch((res)=>{
              
          });
      },
  },
  mounted(){
    
  },
  components: {
      myfooter,
      toast,
  },
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='scss'>
  .voiceRoom{
    width: 100%;
    box-sizing: border-box;
    overflow: hidden;
  } 
  .isheader{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    div{
      display: flex;
      align-items: center;
      .logo1{
          width: 0.72rem;
          height: 0.74rem;
          margin: 0.08rem 0.28rem 0.06rem 0.5rem;
      }
      .logo2{
        width: 1.8rem;
        height: 0.4rem;
      }
    }
    .download{
      width: 1.48rem;
      height: 0.6rem;
      margin: 0.14rem 0.3rem 0.14rem 0;
    }
  }
  .isContainer{
    width: 100%;
    box-sizing: border-box;
    .isTop{
       width: 100%;
       height: 7rem;
       background: url('../../assets/voice1.png') no-repeat 0 0rem;
       background-size:100% 100%; 
       .realTop{
          font-size: .32rem;
          font-weight: 500;
          color: rgba(255, 255, 255, 0.8);
          padding-top: 0.44rem;
          .isImg{
            width: 0.92rem;
            height: 0.92rem;
            border-radius: 100%;
            display: block;
            margin: 0rem auto 0.22rem;
          }
          .isName{
            margin-bottom: 0.2rem;
          }
       }
       .realBottom{
         width:100%;
         box-sizing: border-box;
         background: url('../../assets/voice5.png') no-repeat 0 0rem;
         background-size:100% 100%; 
         padding:0 0.68rem 0.72rem 0.64rem;
         .isroom{
           font-size: 0.24rem;
           text-align: left;
           padding-top: 0.44rem;
           .isTitle{
              font-size: .36rem;
              font-weight: 600;
              color: #000000;
              line-height: 0.48rem;
           }
           .timeNumber{
              margin: 0.16rem 0 0.3rem;
              font-size: 0.24rem;
              font-weight: 400;
              color: rgba(000, 000, 000, .8);
              .isTime{
                color: #FF3C39;
              }
              img{
                width: 0.32rem;
                height: 0.32rem;
                margin-right: 0.1rem;
              }
           }
           .imgName1{
             .isImg{
               width: 0.68rem;
               height: 0.68rem;
               border-radius: 100%;
               margin-right: 0.2rem;
             }
             .isName{
                font-size: .32rem;
                font-weight: 400;
                color: rgba(000, 000, 000, .8);
             }
           }
          .inroom{
            width: 2.34rem;
            img{
              width: 100%;
            }
          }
         }
         .timeNumber,.imgName,.imgName1{
           display: flex;
           align-items: center;
           justify-content: space-between;
         }
       }
       
    }
    .step{
      width: 100%;
    }
    .step1{
      // height: ;
    }


  }
</style>
